import { DataCheckSVGIcon, ExclamationSVGIcon } from "components/SVGIcons";

type Props = {
  profileVerified?: string | null;
};

const VERIFIED = "VERIFIED";

const DebtorVerificationStatus = ({ profileVerified }: Props) => {
  if (!profileVerified) {
    return null;
  }

  if (profileVerified === VERIFIED) {
    return (
      <span className="inline-flex items-center gap-1 text-green-600 uppercase text-xs">
        <DataCheckSVGIcon width={14} height={14} aria-hidden="true" />
        Verified
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1 text-red-500 uppercase text-xs">
      <ExclamationSVGIcon width={14} height={14} aria-hidden="true" />
      Not Verified
    </span>
  );
};

export default DebtorVerificationStatus;
